import '../../vendor/flickity.pkgd.min.js';

/**
 * Initialize Flickity Slider for Slider-articles
 *
 * @param {}
 * @return {void}
 */

export const initializeSliderRecommendations = (slider = '.js-slider-recommendations') => {
  let group = 1;
  let alignSlides = 'left';

  if ($(window).outerWidth() > 1024) {
    group = 3;
    alignSlides = 'center';
  }

  const config = {
    cellAlign: alignSlides,
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    groupCells: true,
    freeScroll: true,
    wrapAround: false,
    lazyLoad: false,
    groupCells: group,
    cellSelector: '.product-item'
  };

  $(slider)
    .not('.flickity-enabled')
    .flickity(config);
};

initializeSliderRecommendations();

$(window).on('shopify:section:load', function(event) {
  initializeSliderRecommendations();
});
